<div class="product--price" [ngClass]="[classes]"  *ngIf="product" >
    <app-product-price [priceRange]="showPriceVariations? priceVariations : null" [price]="price" [discount]="discount" [fontSize]="fontSize" [orientation]="orientation"
                       [originalPrice]="originalPrice" [currency]="currency" [isItemCut]="isItemCut"></app-product-price>
    <div class="uom uppercase">
        <span>{{pkgQty}}</span>
        <app-pricing-tiers *ngIf="canShowPriceTiers" [sku]="sku" [product]="product" [quantity]="quantityForTiers"  [modal]="modal" [position]="position"></app-pricing-tiers>
    </div>
</div>
